<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card height="100%">
        <v-list>
          <template v-for="(item, index) in items">
            <v-subheader primary-title class="primary title white--text" v-if="item.header" :key="item.header" v-html="item.header">
            </v-subheader>
            <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"></v-divider>
            <template v-else-if="!item.isMultiple">
            <router-link tag="v-list-tile"
              :to="{ 
                name: item.link
              }"
              :key="item['.key']" avatar >
                <v-list-tile-avatar>
                  <i class="material-icons primary--text">
                    {{item.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" class="primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
            </router-link>
          </template>
          <template v-else-if="item.isMultiple">
              <v-list-group
                :key="item.title"
                :value="false"
            >
            
              <template v-slot:activator>
                  <v-list-tile-avatar :style="item.style">
                  <i class="material-icons primary--text" style="padding-left: 25px;">
                    {{item.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" class="subheading primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>

                <template
                  v-for="(item1,index1) in item.children"
                >
                 <v-divider v-if="item1.divider" :inset="item.inset" :key="index1"></v-divider>

                  <router-link v-else tag="v-list-tile"
                    style="padding-left: 35px;"
                  :to="{ 
                    name: item1.link
                  }"
                  :key="item1['.key']" avatar >
                <v-list-tile-avatar>
                  <i class="material-icons primary--text">
                    {{item1.icon}}
                  </i>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item1.title" class="primary--text font-weight-bold"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item1.subtitle" class="primary--text font-weight-light"></v-list-tile-sub-title>
                </v-list-tile-content>
                </router-link>
              </template>
            </v-list-group>
          </template>
          </template>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          header: 'Reports'
        },
        // {
        //   title: 'Balance Sheet',
        //   subtitle: 'Manage Balance sheet',
        //   link: 'Balancesheet',
        //   icon: 'account_balance'
        // },
        { divider: true, inset: true },
        {
          title: 'Financial Reports',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'View Balance Sheet, Trading A/C, Capital A/C, P&L Account',
          icon: 'api',
          isMultiple : true,
          children: [
            {
              title: 'Balance Sheet',
              subtitle: 'View Balance Sheet',
              link: 'Bsheet',
              icon: 'format_bold'
            },
            { divider: true, inset: true },
            {
              title: 'Trading Account',
              subtitle: 'View Trading Account',
              link: 'Tradingaccount',
              icon: 'analytics'
            },
            { divider: true, inset: true },
            {
              title: 'Profit & Loss Account',
              subtitle: 'View Profit and Loss Summary',
              link: 'Profitandloss',
              icon: 'local_parking'
            },
            { divider: true, inset: true },
            {
              title: 'Capital Account',
              subtitle: 'View Proprietor Capital Account',
              link: 'Proprietor',
              icon: 'assignment_ind'
            },
            { divider: true, inset: true },
            {
              title: 'Trail Balance',
              subtitle: 'View and Manage Trail Balance',
              link: 'TrailBalanceAccounts',
              icon: 'title'
            },
          ]
        },

        // Other Accounts
        { divider: true, inset: true },
        {
          title: 'Other Reports',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Extra Charges, Sales Team and Other Accounts ',
          icon: 'open_with',
          isMultiple : true,
          children: [
            { divider: true, inset: true },
              {
                title: 'Cash Book',
                subtitle: 'View Cash Account',
                link: 'CashAccount',
                icon: 'luggage'
              },
            { divider: true, inset: true },
            {
              title: 'Product Order Report',
              subtitle: 'View Product Order Report',
              link: 'ProductOrderReport',
              icon: 'agriculture'
            },
            { divider: true, inset: true },
            {
              title: 'Batch Report',
              subtitle: 'View Batch Report',
              link: 'BatchReport',
              icon: 'agriculture'
            },
            { divider: true, inset: true },
            {
              title: 'Extra Charges Account',
              subtitle: 'View Extra Charges Invoices',
              link: 'ExtraChargesInvoices',
              icon: 'copyright'
            },
            { divider: true, inset: true },
            {
            title: 'Incentive Account',
            subtitle: 'View Incentive Invoices',
            link: 'IncentiveInvoices',
            icon: 'note_add'
            },
            { divider: true, inset: true },
            {
              title: 'Discount Account',
              subtitle: 'View Discount Accounts',
              link: 'DiscountAccounts',
              icon: 'feedback'
            },
            { divider: true, inset: true },
            {
              title: 'Interest Account',
              subtitle: 'View Interest Accounts',
              link: 'interestAccounts',
              icon: 'format_italic'
            },
            { divider: true, inset: true },
            {
              title: 'Team Members Account',
              subtitle: 'View & Manage Sales Team Transactions',
              link: 'Staffs',
              icon: 'engineering'
            },
          ]
        },

        //Registers
        { divider: true, inset: true },
        {
          title: 'Enterprise Registers',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'Sales, Purchase, Stock, Receipt, Order, Dispatch, Delivery Registers',
          icon: 'all_out',
          isMultiple : true,
          children: [
            { divider: true, inset: true },
            // {
            //   title: 'Sale Register',
            //   subtitle: 'View Sale Register Report',
            //   link: '/sale-register',
            //   icon: 'grading'
            // },
            // { divider: true, inset: true },
            // {
            //   title: 'Purchase Register',
            //   subtitle: 'View Purchase Register',
            //   link: 'SalePurchaseStatements',
            //   icon: 'summarize'
            // },
            { divider: true, inset: true },
            {
              title: 'Stock Register',
              subtitle: 'View Stock Register Report',
              link: 'Reports',
              icon: 'view_comfy'
            },
            { divider: true, inset: true },
            {
            title: 'Order Register',
            subtitle: 'Manage Order Register',
            link: 'RecordOrder',
            icon: 'content_paste'
            },
            { divider: true, inset: true },
            // {
            //   title: 'Dispatch Register',
            //   subtitle: 'View Dispatch Register',
            //   link: 'RecordDispatch',
            //   icon: 'fact_check'
            // },
            // { divider: true, inset: true },
            // {
            //   title: 'Delivery Register',
            //   subtitle: 'Manage Delivery Registeer',
            //   link: 'RecordDelivery',
            //   icon: 'commute'
            // },
            { divider: true, inset: true },
            {
              title: 'Receipt Register',
              subtitle: 'View & Manage Receipt Register',
              link: 'ReceiptRegister',
              icon: 'chrome_reader_mode'
            },
            { divider: true, inset: true },
            {
              title: 'Payment Register',
              subtitle: 'View & Manage Payment Register',
              link: 'PaymentRegister',
              icon: 'menu_book'
            },
            // { divider: true, inset: true },
            // {
            //   title: 'Receipt Collection',
            //   subtitle: 'View & Manage Staff Receipt Collection',
            //   link: 'ReceiptCollection',
            //   icon: 'currency_rupee'
            // },
          ]
        },

        // Invoices Categories
        { divider: true, inset: true },
        {
          title: 'Invoices Categories',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'View Invoices - Unpicked, Alert, To Restore, To Delete',
          icon: 'repeat',
          isMultiple : true,
          children: [
            { divider: true, inset: true },
            {
              title: 'Alert Invoices',
              subtitle: 'View Alert List',
              link: 'Alertsheet',
              icon: 'notification_important'
            },
            { divider: true, inset: true },
            {
              title: 'Unpaid Invoices',
              subtitle: 'View Due Invoices [Marked] ',
              link: 'Unpickupsheet',
              icon: 'warning'
            },
            { divider: true, inset: true },
            {
              title: 'Restore Invoice',
              subtitle: 'View Deleted Invoices',
              link: 'DeletedInvoiceBook',
              icon: 'wifi_protected_setup'
            },
            { divider: true, inset: true },
            {
              title: 'Multi Print Invoices',
              subtitle: 'Download Multiple Invoices',
              link: 'MultiPrintInvoices',
              icon: 'print'
            },
          ]
        },
        // End of Transactions



        // Product Categories
        // { divider: true, inset: true },
        // {
        //   title: 'Product Reports',
        //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        //   subtitle: 'Product Reports By - Group, Category, Type, Set',
        //   icon: 'repeat',
        //   isMultiple : true,
        //   children: [
        //     { divider: true, inset: true },
        //     {
        //       title: 'Product Group',
        //       subtitle: 'View Reports Via Product Group',
        //       link: 'ProductGroupReports',
        //       icon: 'notification_important'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Product Category',
        //       subtitle: 'View Reports Via Product Category',
        //       link: 'ProductCategoryReports',
        //       icon: 'notification_important'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Product Type',
        //       subtitle: 'View Reports Via Product Type',
        //       link: 'ProductTypeReports',
        //       icon: 'notification_important'
        //     },
        //     { divider: true, inset: true },
        //     {
        //       title: 'Product Set',
        //       subtitle: 'View Reports via Product Set',
        //       link: 'ProductSetReports',
        //       icon: 'notification_important'
        //     },
        //   ]
        // },

        // GST Reports
        { divider: true, inset: true },
        {
          title: 'GST Reports',
          style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
          subtitle: 'View GSTR-1, GSTR-3B, All GST Accounts, View ITC',
          icon: 'shopping_basket',
          isMultiple : true,
          children: [
            { divider: true, inset: true },
              {
                title: 'GST RATE WISE REPORT',
                subtitle: 'View GST Report via rate',
                link: 'GSTAccounts',
                icon: 'backup_table'
              },
            { divider: true, inset: true },
            {
              title: 'GSTR MONTHLY',
              subtitle: 'View GSTR Monthly, Quaterly',
              link: 'GSTMonthly',
              icon: 'backup_table'
            },    
            { divider: true, inset: true },
            {
              title: 'GSTR-1',
              subtitle: 'View GSTR-1',
              link: 'GST1Reports',
              icon: 'backup_table'
            },
            { divider: true, inset: true },
            {
              title: 'GSTR-3B',
              subtitle: 'View GST Accounts',
              link: 'GST3Reports',
              icon: 'backup_table'
            },
            { divider: true, inset: true },
            {
              title: 'ITC',
              subtitle: 'View ITC Summary',
              link: 'IST',
              icon: 'backup_table'
            },
          ]
        },

        // { divider: true, inset: true },
        // {
        //   title: 'P & L Account',
        //   subtitle: 'Manage P&L',
        //   link: 'PandL',
        //   icon: 'domain'
        // },
        
        // { divider: true, inset: true },
        // {
        //   title: 'Prop Account',
        //   subtitle: 'Manage Prop Account',
        //   link: 'Prop',
        //   icon: 'person'
        // },
        
        
        // {
        //   title: 'Defaulter Buyer',
        //   subtitle: 'View Defaulter List',
        //   link: 'Defaultersheet',
        //   icon: 'cancel_presentation'
        // },
        // { divider: true, inset: true },
        // { divider: true, inset: true },
        // {
        //   title: 'Item Sheet',
        //   subtitle: 'View Item Summary',
        //   link: 'Itemsheet',
        //   icon: 'border_all'
        // },
        
        { divider: true, inset: true },
        {
          title: 'Collection Book',
          subtitle: 'View Collection Book',
          link: 'CollectionBook',
          icon: 'agriculture'
        },
        { divider: true, inset: true },
        {
         title: 'SMS Book',
         subtitle: 'Manage SMS',
         link: 'SMSBook',
         icon: 'sms'
        },
        { divider: true, inset: true },
        {
          title: 'Help Book',
          subtitle: 'View Help Book',
          link: 'HelpBook',
          icon: 'contact_support'
        },
        // {
        //   title: 'Interest Sheet',
        //   subtitle: 'View Interest Summary',
        //   link: 'Interestsheet',
        //   icon: 'assessment'
        // },
        // { divider: true, inset: true },
        
        // { divider: true, inset: true },
        // {
        //   title: 'Unpickup Items',
        //   subtitle: 'View Loss Making Items',
        //   link: 'Unpickupsheet',
        //   icon: 'remove_shopping_cart'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Firm Sheet',
        //   subtitle: 'View Firm Details',
        //   link: 'Firmsheet',
        //   icon: 'comment'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Bank Statement',
        //   subtitle: 'View Transaction Details',
        //   link: 'Bankstatement',
        //   icon: 'description'
        // }
      ]
    }
  }
}
</script>
<style scoped>
  .avatar {
    background: #01579b;
    color: white
  }
</style>


// WEBPACK FOOTER //
// src/components/Informations/Sidebar.vue